import { useEffect, useRef } from 'react';
import { motion } from 'motion/react';
import { C } from '../../constants/colors.js';
import { F, N } from '../../constants/fonts.js';

export function ParentCoachingPrompt({ prompt, onDismiss, onLogDone }) {
  const primaryButtonRef = useRef(null);

  useEffect(() => {
    primaryButtonRef.current?.focus();
  }, []);

  if (!prompt) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[1000]"
      style={{ background: 'rgba(15,43,60,0.3)' }}
      onClick={onDismiss}
    >
      <motion.div
        role="dialog"
        aria-modal="true"
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ type: 'spring', damping: 28, stiffness: 260 }}
        onClick={(e) => e.stopPropagation()}
        className="absolute bottom-0 left-0 right-0 px-5 pb-5 pt-4"
        style={{
          background: '#FFFFFF',
          borderRadius: '24px 24px 0 0',
          boxShadow: '0 -8px 40px rgba(15,43,60,0.14)'
        }}
      >
        <div className="mb-4 flex items-start justify-between">
          <div className="mx-auto h-1 w-10 rounded-finley-full bg-[#E5E7EB]" />
          <button
            onClick={onDismiss}
            aria-label="Close coaching prompt"
            className="absolute right-5 top-4 rounded-finley-full px-3 py-1 text-sm"
            style={{ color: C.textMid, fontFamily: N }}
          >
            ✕
          </button>
        </div>

        <div className="mb-2 text-center">
          <span
            className="inline-block rounded-finley-full px-3 py-1 text-[10px] tracking-[0.08em]"
            style={{ background: '#0D9488', color: '#FFFFFF', fontFamily: N, textTransform: 'uppercase', fontWeight: 700 }}
          >
            {prompt.category}
          </span>
        </div>

        <p className="mb-4 text-center text-xs italic leading-5" style={{ color: 'rgba(15,43,60,0.45)', fontFamily: N }}>
          {prompt.why}
        </p>

        <p className="mb-6 text-center leading-8" style={{ color: '#0F2B3C', fontFamily: F, fontSize: 20 }}>
          {prompt.text}
        </p>

        <div className="grid grid-cols-1 gap-3">
          <button
            ref={primaryButtonRef}
            onClick={() => {
              if (onLogDone) onLogDone();
              if (onDismiss) onDismiss();
            }}
            className="min-h-[48px] w-full rounded-finley-lg px-4 py-3 text-sm font-semibold text-white shadow-finley-sm"
            style={{ background: '#0D9488', fontFamily: F }}
          >
            We did this!
          </button>
          <button
            onClick={onDismiss}
            className="min-h-[44px] w-full rounded-finley-lg border-2 bg-transparent px-4 py-3 text-sm"
            style={{ borderColor: '#E5E7EB', color: C.textMid, fontFamily: N }}
          >
            Maybe later
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
